import { Box, IndexFilters, IndexFiltersMode } from '@shopify/polaris';
import { SORT_BILLING_CYCLE } from '../../constants';
import { IUsageFeeBillStatus } from '../../types';
import { capitalizeFirstLetter } from '~/utils';

export const TAB_BILLING_CYCLE_STATUS: string[] = [
  'all',
  IUsageFeeBillStatus.PAID,
  IUsageFeeBillStatus.FAILED,
  IUsageFeeBillStatus.ISSUED,
];

interface BillingSummaryIndexFiltersProps {
  loading?: boolean;
  sortSelected: string[];
  setSortSelected: (sortSelected: string[]) => void;
  selectedTab: string;
  setSelectedTab: (selectedTab: string) => void;
}

export const BillingSummaryIndexFilters: React.FC<BillingSummaryIndexFiltersProps> = ({
  loading,
  sortSelected,
  setSortSelected,
  selectedTab,
  setSelectedTab,
}) => {
  const tabs = TAB_BILLING_CYCLE_STATUS.map((tabStatus, index) => ({
    key: tabStatus,
    content: capitalizeFirstLetter(tabStatus),
    index,
    id: `${tabStatus}-${index}`,
  }));

  return (
    <Box padding="100" paddingInlineStart="0" borderBlockEndWidth="025" borderColor="border">
      <div className="Polaris-GIndexFilters--no-border">
        <IndexFilters
          tabs={tabs}
          sortOptions={SORT_BILLING_CYCLE}
          sortSelected={sortSelected}
          onSort={setSortSelected}
          loading={loading}
          hideFilters
          hideQueryField
          selected={tabs.findIndex((tab) => tab.key === selectedTab)}
          onSelect={(value) => setSelectedTab(tabs[value].key)}
          onQueryChange={() => {}}
          mode={IndexFiltersMode.Default}
          canCreateNewView={false}
          setMode={() => {}}
          filters={[]}
          onQueryClear={() => {}}
          onClearAll={() => {}}
        />
      </div>
    </Box>
  );
};
